/* eslint-disable max-len */

export default {
  lang: 'Italiano',
  homeScreen: {
    title: 'Le Isole Bahamas',
    subTitle: 'Pronti al decollo',
    stayConnected: 'Resta in contatto',
    comingSoon: 'Prossimamente',
    messages: 'Messaggi',
  },
  notification: {
    newAndNow: 'Novità & Adesso!',
    alert: 'Allerta',
    contest: 'Concorso',
    message: 'Contenuto',
    events: 'Evento',
    news: 'Notizie',
    other: 'Notifica',
    welcome: 'Benvenuto',
  },
  directory: {
    view: 'Visualizza ora >',
    reset: 'Ripristina filtri >',
    results: 'Quantità di risultati',
    acco: 'Filtra per tipo di alloggio',
    price: 'Filtra per prezzo',
    island: 'Filtra per isola',
    additional: 'Filtri aggiuntivi:',
    accessibleproperty: 'Proprietà accessibile',
    beachfront: 'Spiaggia',
    casino: 'Casinò',
    divecenter: 'Dive Center',
    fishinglodge: 'Fishing Lodge',
    golf: 'Golf',
    marina: 'Marina',
    selfcatering: 'Self-Catering',
    waterfront: 'Lungomare',
    noResults: 'Nessun risultato trovato. prova con una ricerca diversa.',
    search: 'Cerca un annuncio...',
    back: 'indietro',
  },
  loginScreen: {
    title:
      'Programma di formazione e abilitazione alla vendita per agenti di viaggio',
    welcome: {
      headerTop: 'Benvenuti al',
      headerBottom: 'Programma Specialista delle Bahamas',
    },
    version2: {
      homeTitle:
        'Vediamo se riusciamo a trovare un profilo esistente per lei nel nostro sistema.',
      homeTitleSub:
        "Inserite l'indirizzo e-mail che utilizzate di solito per accedere ai programmi di formazione.",
      noAccount:
        "Nessun account trovato ({email}), provare con un'altra e-mail o creare un account ora.",
      continueButton: 'Continua',
      success:
        'Il tuo account è stato aggiornato con successo! Verrete reindirizzati a breve alla pagina iniziale.',
      successNewAccount:
        "Per completare la registrazione, riceverete un'e-mail di conferma per verificare il vostro account.",
      loginButton: 'Accesso',
      matchFound:
        'Abbiamo trovato una corrispondenza, inserire la password per continuare.',
      magicLink: "Effettuare l'accesso tramite un link inviato via e-mail:",
      magicLinkButton: 'Richiesta di collegamento magico',
      magicLinkTitle:
        'Riceverete un link diretto al vostro indirizzo e-mail che vi consentirà di accedere immediatamente.',
      otherEmailButton: 'Invia',
      title:
        'Vi preghiamo di completare tutte le informazioni qui di seguito per creare il vostro profilo personale e le informazioni di contatto.',
      titleIndustry:
        'Vi preghiamo di completare tutte le informazioni qui di seguito per creare il vostro profilo personale e le informazioni di contatto.',
      register: 'Creare un account',
      agent: 'Consulente di viaggio',
      visitor: 'Visitatore del settore',
      step1: 'Passo 1: Tipo di utente',
      step2: 'Fase 2: Creare un account',
      step3: 'Fase 3: Creare il profilo',
      marketingOptIn:
        'Siete sicuri di non essere interessati a rimanere in contatto con il team di travel trade di questo programma?',
      optIn: 'Sì, sono interessato',
      optOut: 'Non interessato',
      step2Sub1: 'Parlaci di te',
      step2Sub2: 'Parlateci della vostra attività',
      privacyHead: 'PREFERENZE DI COMUNICAZIONE',
      privacySub:
        'Selezionate le caselle sottostanti per assicurarvi di ricevere le comunicazioni più importanti dal team del settore viaggi del fornitore (aggiornamenti e annunci sui prodotti, premi, incentivi, FAM, ecc.) e le iniziative di networking e supporto alle vendite del settore viaggi di TravPRO Mobile.',
      privacy:
        'Proteggiamo la vostra privacy e non vendiamo, abusiamo o tradiamo mai la vostra fiducia.',
      store: 'Scaricate facilmente questo programma dal vostro app store:',
      powered: 'ALIMENTATO DA',
      toastMessage: {
        forgotSuccess:
          'Abbiamo inviato per e-mail il link per la reimpostazione della password! Sarete reindirizzati alla pagina di accesso entro 10 secondi.',
        emailNotExisting: "L'indirizzo e-mail inserito non esiste.",
        magicLinkMessage: 'Attenda, la stiamo registrando in questo momento.',
        magicLinkError:
          'Non siamo riusciti a trovare il suo account nel nostro database, la preghiamo di accedere manualmente. Verrete reindirizzati entro 10 secondi.',
        magicLinkError1:
          "Non è stato possibile trovare un token valido, si prega di effettuare il login o di richiedere un nuovo link magico. Se il problema persiste, contattateci all'indirizzo: info@travpromobile.com.",
        magicLinkError2:
          'Non siamo riusciti a trovare il suo account nel nostro database, la preghiamo di accedere manualmente. Verrete reindirizzati entro 10 secondi.',
        magicLinkSuccess:
          "Controllate la vostra e-mail all'indirizzo {email}. C'è un link magico che vi farà accedere.",
        magicLinkErrorWait:
          'Attendere 5 minuti tra le richieste di link magico.',
        emailNotFoundError:
          "L'indirizzo e-mail inserito non è presente nei nostri archivi. Si prega di verificare la presenza di errori ortografici o di creare un account.",
      },
      errors: {
        zipCodeNotFound: 'Codice postale non trovato, riprovare',
        zipCodeOnlyNumbers: 'ZipCode può contenere solo numeri',
        password: 'Inserire una password',
        passwordNotMatching: 'Le password inserite non corrispondono',
        passwordTooShort: 'La password deve essere di almeno 8 caratteri',
        emailExists:
          'Questo indirizzo e-mail esiste già o non è valido. Provare con un altro indirizzo e-mail o accedere al proprio account.',
        fillInAllFields: 'Compilare tutti i campi richiesti',
        fillInEmail: 'Inserite il vostro indirizzo e-mail.',
        emailNotExisting: "L'indirizzo e-mail inserito non esiste.",
      },
      fields: {
        forgotSubCopy: 'Avete dimenticato la password e volete cambiarla? ',
        forgotSubCopy2:
          "Volete evitare completamente la password? Vi invieremo un'e-mail con un link magico che vi farà accedere automaticamente al programma.",
        city: 'Città',
        companyName: 'Nome della società',
        role: 'Il vostro ruolo',
        description: "Quale descrive meglio l'attività della vostra azienda?",
        country: 'Paese',
        password: 'Password',
        passwordRegister: 'Scegliere la password (minimo 8 caratteri)',
        passwordConfirm: 'Conferma la password',
        firstName: 'Nome (dato)',
        lastName: 'Cognome (Famiglia)',
        agency: "Nome dell'agenzia",
        title: 'Il vostro ruolo (selezionare uno)',
        company: 'Nome della società',
        select: "Selezionare un'opzione qui sotto",
        state: 'Stato',
        province: 'Provincia/Regione/Stato',
        zipCode: 'Codice postale',
        postalCode: 'Codice postale',
        affiliate: 'Qual è il vostro gruppo di appartenenza principale?',
        hostAgency: "L'agenzia ospitante?",
        executive: 'Esecutivo',
        management: 'Gestione',
        marketing: 'Marketing',
        sales: 'Vendite',
        coordinator: 'Coordinatore',
        opt: 'Rimanete in contatto con il team del settore viaggi di questo programma e ricevete gli aggiornamenti.',
        optMarketing:
          'Rimanete in contatto con TravPRO per programmi ed eventi simili.',
        retail: 'Fronte del negozio al dettaglio',
        home: 'Agente a domicilio',
        independent: 'Contraente indipendente',
        host: 'Agenzia ospitante',
        call: 'Call center o agenzia web',
        other: 'Altro',
        describes: "Cosa descrive meglio l'attività sua e della sua agenzia?",
      },
    },
    forgot: 'Reimpostare la password',
    forgotCopylong:
      "Avete dimenticato la password? Cliccate sul pulsante qui sotto e vi invieremo un'e-mail per reimpostare la password.",
    forgotHeader:
      "Fornisci l'indirizzo email che hai utilizzato quando ti sei registrato per il tuo account Bahamas Specialist. Ti invieremo un'e-mail che ti permetterà di reimpostare la tua password",
    sellingPoints: {
      0: 'Apprendi, promuovi e vendi ovunque sei',
      1: 'Formazione multimediale su tutti i dispositivi',
      2: 'Attestato di completamento',
      3: 'Presentazioni di vendita già pronte',
      4: 'Materiali promozionali ad alto impatto',
      5: 'Consigli esperti e promozioni',
      6: 'Elenco prodotti in tempo reale',
      7: 'Notizie tempestive e aggiornamenti',
    },
    emailPrompt:
      'Inserisci  indirizzo email e password per confermare che sei un agente di viaggio',
    tAndC: {
      agree: 'Continuando a navigare accetti la nostra ',
      privacyPolicy: 'politica sulla privacy',
      and: ' e ',
      termsConditions: 'i nostri termini e condizioni',
    },
    fields: {
      agency: 'Agenzia',
      email: 'Email',
      password: 'Password',
      passwordConfirm: 'Conferma la password',
      firstName: 'Nome',
      lastName: 'Cognome',
      agencyName: "Nome dell'agenzia",
      stateProvince: 'Stato/Provincia',
      required: 'Obbligatorio',
      invalidEmail: 'Indirizzo email non valido',
      opt: 'Resta in contatto! Sì, desidero ricevere comunicazioni su notizie, eventi, incentivi, tour per operatori turistici e altro!',
      forgot: 'Reimpostare la password',
      forgotCopylong:
        "Avete dimenticato la password? Cliccate sul pulsante qui sotto e vi invieremo un'e-mail per reimpostare la password.",
    },
    noAgent: {
      noAgentButton: 'Non sono un consulente',
      title: 'Grazie per il tuo interesse per le Bahamas.',
      messageWeb:
        'I contenuti di questo sito sono riservati esclusivamente agli agenti di viaggio. Per saperne di più sulle Bahamas visita:',
      messageMobile:
        "Alcuni contenuti di quest'applicazione sono riservati esclusivamente agli agenti di viaggio, ma puoi visualizzare un'anteprima dell'applicazione cliccando su \"Continua\".",
      continue: 'Continua',
      visitWebsite: 'Visita il sito web',
    },
    newUser: 'Nuovo utente',
    register: 'Registrati',
    registered: 'Questo indirizzo email è già registrato',
  },
  welcomeScreen: {
    title: 'Benvenuto nella Guida commerciale per specialisti delle Bahamas',
    helloUser: 'Salve {{nome}}',
    hello: 'Salve,',
    fromAgency: 'di {{agenzia}}',
    notUser: 'Non sei {{nome}}?',
    introOnline:
      "Allenati subito online o precarica i contenuti in modo che siano sempre disponibili per l'uso offline!",
    introOffline:
      'Hai già precaricata la versione più recente. Inizia a fare formazione o a vendere quando e dove vuoi!',
    startTraining: 'Inizia la formazione',
    continueTraining: 'Continua la formazione',
    graduated: 'Congratulazioni!',
    downloader: {
      preload: 'Precaricamento',
      stop: 'Stop',
      init: 'Inizializzazione',
      lastUpdate: 'Ultimo aggiornamento',
    },
  },
  trainingScreens: {
    review: 'Rivedi',
    start: 'Inizia',
    continue: 'Continua',
    restart: 'Riavvia',
    durationInMinutes: '{Numeri} minuti',
    percentageComplete: '{numero} completato',
    unlock: 'Sblocca questo capitolo completando il capitolo {numero}.',
    unlockSubtitle:
      'Sblocca altri capitoli completando i capitoli di formazione.',
    allUnlocked: 'Hai completato tutti i capitoli !',
    certificate: 'Attestato',
    courseComplete: 'Continua',
    endReached: 'Hai raggiunto la fine',
    retainEnd:
      "Usa la barra superiore per navigare all'interno di questo capitolo o clicca sul tasto indietro per tornare alla panoramica.",
    watchListenRead: 'Leggi, guarda e scopri di più',
    trouble:
      'Sembra che ci siano dei problemi, rileggi il contenuto delle pagine precedenti e riprova.',
    confirm: 'Conferma la risposta',
    choose: 'Scegli una risposta',
    skip: 'Invio',
    viewAllTitle: 'Consiglio di formazione',
    viewAll:
      'Per passare alla pagina successiva, clicca sulle icone per visualizzare i contenuti integrativi. Sono stati forniti video, mappe e altre informazioni utili per migliorare la tua formazione e garantirti lo status di PRO.',
    fillBlanks: 'Riempi lo spazio o gli spazi in bianco',
    next: 'Domanda successiva',
    retry: 'Riprova',
    fastTrackText: {
      success:
        'Congratulazioni, hai superato il corso Fast Track e hai sbloccato il resto della formazione!',
      failed:
        'Purtroppo, non hai superato il corso Fast Track. Puoi riprendere la formazione per ottenere il diploma!',
    },
    fastTrack: 'Diventa un…',
    fastTrackExplanation: '…',
    fastTrackButton: 'Clicca qui per sostenere il…',
    grading: 'Il tuo punteggio finale è: {punteggio}%',
  },
  nav: {
    home: 'Home',
    train: 'Esercitati',
    learn: 'Esercitati',
    retain: 'Ricorda',
    directory: 'Elenco alberghi',
    showcases: 'Vetrine',
    promote: 'Promuovi',
    sell: 'Vendi',
    info: 'Informazioni',
    rewards: 'Ricompense',
    media: 'Media',
    favorites: 'Preferiti',
    contact: 'Contatto',
    reportCard: 'Visualizza diploma',
    accountSettings: 'Impostazioni account',
    messages: 'Messaggi',
    search: 'Cerca',
  },
  contentHeaders: {
    train: 'Esercitati',
    retain: 'Ricorda',
    subapps: 'Moduli Specialista delle Bahamas',
    maintrainings: "L'ESSENZIALE",
    subtrainings: 'MODULI DI SPECIALIZZAZIONE',
  },
  pageDescriptions: {
    train: 'Informati, impegnati e diventa esperto.',
    retain:
      'La risorsa ideale per conservare le tue conoscenze e incentivare le tue vendite. Usa quest’area per rispondere con competenza a domande relative al prodotto o come presentazione in occasione di una vendita, in qualsiasi momento, ovunque e da qualsiasi dispositivo.',
    promote: 'Inizia la conversazione con i tuoi clienti e potenziali tali',
    sell: 'Rispondi alle domande dei tuoi clienti e concludi la vendita.',
    favorites: 'Controlla i tuoi contenuti preferiti',
    search: 'Guarda tutti i contenuti',
    subapps: 'Moduli Specialista delle Bahamas',
    maintrainings: 'Completa questi moduli essenziali per ottenere il diploma.',
    subtrainings:
      'Sali di livello e guadagna un distintivo per ogni modulo sottostante.',
  },
  general: {
    chapterTitle: 'Capitolo ',
    next: 'Avanti',
    yes: 'Sì',
    no: 'No',
    previous: 'Precedente',
    submit: 'Invia',
    back: 'Indietro',
    close: 'Chiudi',
    page: 'Pagina',
    search: 'Cerca',
    showcase: 'Vetrine',
    logIn: 'Accedi',
    logOut: 'Esci',
    viewItem: 'Vedi {inserire}',
    imageNotFound: 'Immagine non trovata',
    noResultsFor:
      'Non è stato trovato alcun risultato per: {{chiave di ricerca}}',
    noFavorites: 'Non hai ancora preferiti.',
    noMessages: 'Non hai ancora ricevuto messaggi!',
    resultsFor: 'Risultati per: {{chiave di ricerca}}',
    showAll: 'Mostra tutto',
    connectionError: 'Errore di connessione',
    alreadyExists: 'Già esiste',
    pageNotFound: '404 Pagina non trovata!',
    oops: 'Oh oh',
    overview: 'Torna alla panoramica',
    complete: 'Continua',
    courseComplete: 'Corso completato!',
    chapterComplete: 'Capitolo completato!',
    message: '{Numero} Messaggio',
    messagePlural: '{Numero} Messaggi',
  },
  itemTypes: {
    image: 'Immagine',
    brochure: 'Raccolta',
    layout: 'Layout',
    web: 'Sito Web',
    pdf: 'PDF',
    carousel: 'Raccolta',
  },
  questions: {
    dials: 'Ruota i selettori in base alla risposta',
    fitb: 'Riempi lo spazio o gli spazi in bianco',
    flip: 'Modifica il numero in base alla risposta',
    multipleChoice: 'Scegli la risposta o le risposte',
    slider: 'Scegli la risposta  usando il cursore',
    map: 'Rispondi alla domanda cliccando sulla posizione corretta sulla mappa',
    dropdown: 'Scegli…',
    true: '1',
    false: 'Falso',
  },
  reportCard: {
    download: 'Scarica',
    email: 'Email',
    print: 'Stampa',
  },
  cookies: {
    consent: 'CONSENTI',
    optout: 'Opt-out',
    settings: 'Impostazioni privacy',
    message:
      "Non ci hai detto nulla sulle tue preferenze in materia di privacy! Non c'è problema, ma vorremmo offrirti la migliore esperienza di utilizzo della Guida commerciale.",
    disabled: "Sembra che tu abbia disabilitato l'uso dei cookies.",
    use: "{{nome app}} richiede l'uso di cookies per offrirti un'esperienza ottimale.",
    details: 'A cosa servono i cookies?',
    enable: 'Guarda come abilitare i cookies {{qui}}.',
    here: 'qui',
  },
  notLoggedIn: {
    super: "Non hai effettuato l'accesso",
    title: "Devi effettuare l'accesso per visualizzare questo contenuto",
    guest: 'Ospite',
  },
  demo: {
    message:
      'Questo sito web è una dimostrazione del prodotto finale. È attualmente in fase di sviluppo e non è un prodotto completo.',
    consent: 'Ho capito!',
  },
  share: {
    header: 'Condividi questa risorsa sui tuoi social media preferiti!',
    download: 'Scarica',
  },
  sharing: {
    copyURL: 'Copia link',
    copied: 'Copiato',
  },
  breadCrumbs: {
    page: 'Pagina',
  },
  onMobile: {
    header:
      "Sembra che tu stia cercando di accedere all'applicazione {nome app} da un dispositivo mobile.",
    body: "Per scaricare questo programma è sufficiente visitare l'app store e cercare {nome app} o cliccare su uno dei pulsanti sottostanti.",
    benefits: {
      1: 'Attestato di completamento',
      2: 'Materiale di marketing gratuito e di alta qualità',
      3: 'Qualificati per partecipare ai tour per gli operatori turistici',
      4: 'Informazioni e risorse sulle vendite ad alto impatto',
      5: "Accesso all'applicazione mobile della Guida commerciale",
      6: 'Consigli di vendita',
      header: 'Questo ti fornirà:',
    },
  },
  custom: {
    splitUsers: 'Sono un…',
    brandAmbassador: 'Portavoce della marca',
    travelPro: 'Agente di viaggio',
  },
  rewards: {
    menu: {
      home: 'Home\nRicompense',
      achievements: 'Risultati\nFormazione',
      bookings: 'Incentivi\nBadge',
      form: 'Invia\nPrenotazioni',
    },
    rewards: 'Premi',
    title: 'Ti diamo il benvenuto nel Centro premi e risultati',
    subheader:
      'Monitora e condividi i risultati e gli incentivi della formazione',
    button: 'Invia la tua prenotazione',
    viewAllBookings: 'Prenotazioni',
    viewDashboard: 'Dashboard punti',
    viewRewards: 'Panoramica',
    overview: {
      valid:
        '*Le prenotazioni inserite sono valide solo dopo il completamento del viaggio del cliente.',
    },
    home: {
      entries: 'Voci attuali',
      trainingAchievements: 'RISULTATI DELLA FORMAZIONE',
      trainingAchievementsText:
        'Tieni traccia dei tuoi progressi, delle certificazioni e dello stato dei premi da questa pagina. Potrai scaricare e condividere il tuo diploma di specialista degli Stati Uniti, così come tutti i badge che hai guadagnato in Esperienze e Specializzazioni dei partner.',
      bookingContests: 'DASHBOARD INCENTIVI',
      bookingContestsText:
        'Monitora e gestisci i programmi di incentivi attuali in tutta facilità dalla Dashboard incentivi. ',
      submitBooking: 'INVIA LE PRENOTAZIONI',
      submitBookingText:
        'Da questa pagina potrai inviare le prenotazioni per includerle in Incentivi per le prenotazioni.',
      currentContest: 'INCENTIVI ATTUALI',
      noContests: 'Attualmente non sono presenti Incentivi per i badge.',

      contestTerms: 'i nostri termini e condizioni',
      noContest: 'Il concorso non è attualmente disponibile.',
    },
    bookingsView: {
      title: 'Prenotazioni',
      infoMessage:
        "Ordinare utilizzando i pulsanti in alto e fare clic su qualsiasi record per gestire i dettagli dell'invio. Tutte le iscrizioni in sospeso saranno verificate entro 72 ore",
    },
    leaderboardScreen: {
      prizes: 'Premi',
      tAndC: 'Offerta soggetta a termini e condizioni*',
    },
    dashboardView: {
      title: 'Dashboard incentivi',
      subtitle:
        'Tieni traccia delle tue attività relative agli incentivi da questa pagina.',
      badge: 'Incentivi per i badge',
      activity: 'Incentivi per le prenotazioni',
      manage: 'Gestisci prenotazioni',
      manageSub:
        'Seguite le prenotazioni attuali qui sotto, oppure visualizzate le prenotazioni archiviate utilizzando il menu a tendina.',
      noBadgeIncentives: 'Attualmente non sono presenti Incentivi per i badge.',
      noBookings: 'Nessun record da visualizzare.',
      state: {
        approvedEntries: 'Voci Approvate',
        pendingEntries: 'Iscrizioni in Sospeso',
        declinedEntries: 'Voci Rifiutate',
        viewAll: 'Visualizza Tutti',
      },
      currentYear: 'Anno Corrente',
      archivedBookings: 'Prenotazioni Archiviate',
    },
    bookingForm: {
      title: 'Modulo di invio prenotazione',
      subTitle: 'Inserisci la tua prenotazione:',
      required: '* Indica un campo obbligatorio',
      email: "Email dell'agente",
      agentFirstName: "Nome dell'agente",
      agentLastName: "Cognome dell'agente",
      company: "Nome dell'azienda",
      iata: 'IATA/CLIA #',
      stateProvince: 'Stato/Provincia',
      postalCode: 'Codice postale *',
      country: 'Paese',
      bookingNumber: 'Numero di conferma della prenotazione',
      numberOfGuests: 'Numero di ospiti adulti',
      bookingDate: 'Data della prenotazione',
      tourOperator: 'Grossista',
      firstName: 'Nome',
      lastName: 'Cognome del cliente',
      accommodation: "Nome dell'hotel",
      guests: 'Numero di passeggeri',
      select: "Seleziona un'opzione",
      wholesaler: 'Grossista',
      arrivalDate: 'Data di check-in',
      departureDate: 'Data di check-out',
      lengthOfStay: 'Durata del soggiorno (in notti)',
      reservationNumber: "Numero di conferma dell'hotel",
      rooms: 'Numero di camere',
      stay: 'Durata del soggiorno (in notti)',
      airline: 'Compagnia aerea / Vettore (codice a 2 lettere)',
      originAirport: 'Aeroporto di origine (codice a 3 lettere)',
      destination: 'Destinazione / Isola (codice a 3 lettere)',
      cost: 'Costo totale della prenotazione (usare solo decimali)',
      file: 'Caricamento prova RezSnap™',
      disclaimer: '* Campi obbligatori',
      button: 'Invia la tua prenotazione',
      sub: 'Le tue informazioni',
      sub2: 'Informazioni sulla prenotazione',
      propertyCharterCompany: 'Proprietà / Compagnia di charter',
      flightNumber: 'Numero di volo',
      bookingType: 'Tipo di prenotazione',
      group: 'Gruppo',
      fit: 'FIT',
    },
    TermsAndConditions: {
      title: 'Terms and Conditions',
      subTitle: 'Bahamas Specialist Quarterly Rewards',
      body1:
        'All posting must be accompanied by a zero-balance proof of sale document that corresponds with each individual booking that you have posted. Awardees will be selected based on the totality of verified proof of sale documents corresponding with each listed booking. Postings must follow all Bahamas Specialist Rewards rules for eligibility. Awards are not transferable and must be redeemed within three (3) months of award notification. Any unused, unclaimed or declined awards will be forfeited. Awards will be issued quarterly, and eligibility will be verified based on completed travel.',
      body2:
        'To be eligible you must reside in the U.S or Canada, and be age of majority or older in the state, province, or territory of residence. Tour Operator employees are NOT eligible for drawings, and will NOT be considered for additional prizes. Residents of the Province of Quebec are NOT eligible for drawings, and will NOT be considered for additional prizes.',
      body3:
        'Reward issuance may require proof of accreditation as a retail/home-based travel counselor. Available rewards are subject to change during the course of the program.',
      body4: 'Privacy and Use of Personal Information',
      body5:
        'Participating agents (i) grants to the Rewarder the right to use his/her name, city, state, province, postal code, age of majority confirmation, telephone number and e-mail address for including but not limited to contacting and announcing the Awardees and provision of awards; (ii) grants to the Awardee the right to use his/her personal information for publicity and promotional purposes relating to the awards, in any and all media now known or hereafter devised, without further compensation unless prohibited by law; and (iii) acknowledges that the Awardees may disclose his/her personal information to third-party agents and service providers in connection with any of the activities listed in (i) and (ii) above.',
      button: 'Indietro',
    },
    thankYouPage: {
      thanks: 'Grazie',
      congrats: 'Congratulazioni, ',
      body: 'abbiamo ricevuto la tua prenotazione, che è stata inviata al supervisore della campagna per la verifica.',
      link: 'Ricorda che per essere eletti vincitori è necessario aver completato il programma Base di USA Discovery Program',
    },
  },
  search: {
    pages: 'Pagine',
    resources: 'Risorse',
  },
};
